import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useWallet } from '~/wallet';
import { AppPage } from '~/ui/AppPage';
import { Card, CopyValue } from '~/ui/primitives';
import { AccountIdentity } from './AccountIdentity';

export const Account = observer(() => {
  const { identity } = useWallet();

  if (!identity.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  const addr = identity.addresses!;

  return (
    <AppPage title="Account">
      <AccountIdentity account={identity.account} />
      <Card>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-5)' }}>
          <CopyValue label="Cere (SS58)" value={addr.cere} />
          <CopyValue label="Solana (base58)" value={addr.solana} />
          <CopyValue label="EVM (0x)" value={addr.evm} />
        </div>
      </Card>
      <p style={{ margin: 0, color: 'var(--text-muted)', font: '400 13px/1.5 var(--font-sans)' }}>
        These addresses are derived from your passkey on this device. The same identity works across Cere, Solana, and
        EVM.
      </p>
    </AppPage>
  );
});
